// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import '@/permission'
import 'babel-polyfill'
import tool from "./utils/tool";
Vue.use(tool);
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN'
Vue.use(ElementUI, { locale })

import 'normalize.css/normalize.css'
import echarts from 'echarts'
Vue.use(echarts)

Vue.config.productionTip = false

import { handleFileDown } from '@/utils/util.js'
Vue.prototype.handleFileDown = handleFileDown

// 视频播放器
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

/* eslint-disable no-new */
new Vue({
        el: '#app',
        router,
        components: { App },
        template: '<App/>'
    })
    // 时间过滤器
Vue.filter("date", function(time) {
    if (!time) {
        return time
    } else {
        time = time.substring(0, 16)
        return time
    }

});


// WEBPACK FOOTER //
// ./src/main.js